import $ from 'jquery';
const productFiltering = {
    init: function () {
        const productsGrid = document.querySelector('.js-products-grid');
        const filters = document.querySelectorAll('.js-products-filters-item');
        if (!filters) {
            return;
        }
        filters.forEach(filter => {
            filter.addEventListener('click', () => {
                filters.forEach(filter => {
                    filter.querySelector('.value-option').classList.remove('active');
                });
                filter.querySelector('.value-option').classList.add('active');
                const filterAttr = filter.getAttribute('data-filter');
                const filterValue = filterAttr === '*' ? 'js-products-grid-item' : filterAttr;

                $(productsGrid).children().each(function () {

                    if(this.classList.contains(filterValue)) {
                        $(this).show()
                    } else {
                        $(this).hide();
                    }

                })


            })
        })


    },
}
export default productFiltering;